<template>
  <div>
    <h1>Operations Dashboard</h1>
  </div>
</template>

<script>
export default {
  name: 'OperationsDashboard'
}
</script>